import { render, staticRenderFns } from "./MyBizTaskNotifyList.vue?vue&type=template&id=babdb378&scoped=true&"
import script from "./MyBizTaskNotifyList.vue?vue&type=script&lang=js&"
export * from "./MyBizTaskNotifyList.vue?vue&type=script&lang=js&"
import style0 from "./MyBizTaskNotifyList.vue?vue&type=style&index=0&id=babdb378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babdb378",
  null
  
)

export default component.exports